// extracted by mini-css-extract-plugin
export default {"Button2":"Button2_Button2__H60R1","button":"Button2_button__hYB48"};